import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import PrintIcon from '@material-ui/icons/Print';

import { roles } from '../services/user';

export default function ConfirmDialog({
  title,
  children,
  reregistrationBlock,
  clearForm,
  loading,
  canReregistritionByDays,
  onConfirm = Function.prototype,
  onClose = Function.prototype,
  queryId,
  ...rest
}) {

  const redirectToPrint = () => window.location = `/consulta/${queryId}`;

  const needsClear = () => {
    if(reregistrationBlock){
      clearForm();
      window.location = '/consulta';
      onClose();
    }
    else
      onClose();
  };

  return <Dialog {...rest} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{children}</DialogContentText>
    </DialogContent>

    <DialogActions>
      { roles('profile.report') && queryId &&
       <Button color="primary" onClick={redirectToPrint}>
         <PrintIcon style={{color: 'rgba(0, 0, 0, 0.54)'}}/>
       </Button>
      }
      <Button color="primary" disabled={loading} onClick={needsClear}>
        {(roles('profile.allow_requery') ||
        (!reregistrationBlock || canReregistritionByDays))
          ? 'Cancelar' : 'Ok'}
      </Button>
      { (roles('profile.allow_requery') || (!reregistrationBlock || canReregistritionByDays)) &&
       <Button color="primary" disabled={loading} onClick={onConfirm} autoFocus>Continuar</Button>}
    </DialogActions>

    { loading && <LinearProgress variant="query" /> }
  </Dialog>;
}
